export const forbiddenListeners: Set<(response: Response) => void> = new Set()

export function notifyForbiddenListeners(response: Response) {
  // console.log('notifyForbiddenListeners', response)
  for (const listener of forbiddenListeners) {
    try {
      listener(response)
    } catch (_e) {
      // ignored
    }
  }
}

export interface RequestStartedEvent {
  url: string
  method: string
  endpoint: string
  startedAt: DOMHighResTimeStamp
  body: string | null
  args: unknown
}

export const customRequestListeners: Set<(evt: RequestStartedEvent) => void> = new Set()

export function hasCustomRequestListeners() {
  return customRequestListeners.size > 0
}

export function notifyRequestStarted(evt: RequestStartedEvent) {
  for (const listener of customRequestListeners) {
    try {
      listener(evt)
    } catch (_e) {
      // ignored
    }
  }
}
